import React, { useEffect } from "react";
import { ProductWarrantyStatusFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";

const ProductWarrantyStatusForm = ({ inititalValues, onSubmit }) => {
  const schema = yup.object().shape({
    warranty_status: yup.string().required("Required"),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (inititalValues) {
      reset({ ...inititalValues });
    }
  }, [inititalValues]); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ProductWarrantyStatusFormStyled>
      <form>
        <div className="f_title">Edit - Warranty Status</div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Dropdown
                {...field}
                label={"Warranty Status"}
                options={[
                  {
                    label: "None",
                    value: "1",
                  },
                  {
                    label: "Under Warranty",
                    value: "2",
                  },
                  {
                    label: "Warranty Expire",
                    value: "3",
                  },
                  {
                    label: "Warranty Cancel",
                    value: "4",
                  },
                ]}
                errors={errors.warranty_status?.message}
              />
            )}
            name="warranty_status"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.DateTime
                {...field}
                label={"Warranty cancel date"}
                errors={errors.warranty_cancel_date?.message}
              />
            )}
            name="warranty_cancel_date"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Admin Note"}
                errors={errors.warranty_status_note?.message}
              />
            )}
            name="warranty_status_note"
            defaultValue=""
          />
        </div>
        <div className="btn_submit">
          <Buttons.BgStandard
            type="button"
            label={"Update and Save"}
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </form>
    </ProductWarrantyStatusFormStyled>
  );
};

ProductWarrantyStatusForm.propTypes = {};

export default ProductWarrantyStatusForm;
